export default __webpack_public_path__ + "static/media/saint_aubin7.7a663ce5.jpg";